import { Lock } from 'lucide-react';

type ProtectedFieldLockIconProps = {
	className?: string;
	size?: number;
};

export function ProtectedFieldLockIcon({ className, size }: ProtectedFieldLockIconProps) {
	return (
		<Lock
			className={className}
			size={size}
			strokeWidth={2}
		/>
	);
}
